import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { vignetteStylesheetsView_template } from '../components/templates/vignetteStylesheetsView_template';
import { header } from './header';

declare var ko: any;
declare var page: any;

export class vignette_stylesheets_view extends vnModule_knockoutJS {

    protected stylesheetView: vignetteStylesheetsView_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string {
        return 'vignette_stylesheets_view';
    }

    buildContent(): Array<Element> {
        this.stylesheetView = new vignetteStylesheetsView_template('vignette_stylesheets_view', this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Vignette Stylesheet');

        return [this.stylesheetView.build()];
    }

    public fillPage(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.stylesheetView.setBrand(idBrand);
        }
        this.getStylesheet();
    }

    protected cancel() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page(`/brand/${idBrand}/categorization/vignette-stylesheets`);
    }

    public edit(id) {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page(`/brand/${idBrand}/categorization/vignette-stylesheets/edit/${id}`);
    }

    protected getStylesheet() {
        this.loadingIn(this.stylesheetView.builtTemplate);

        let idStylesheet = this.getVnAppZone().getApp().params.id;
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = `/api/brand/${idBrand}/vignette-stylesheets/get/${idStylesheet}`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON({})]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetStylesheetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetStylesheetRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.stylesheetView.setStylesheet(responseParsed.stylesheet);
            });
            obj.loadingOut(obj.stylesheetView.builtTemplate);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/vignette_stylesheets_view.ts